export interface CreditIQTokenBundle {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
}

export enum CreditIQEnvironment {
    staging = "di-staging",
    prod = "di-prod",
}

export enum CreditAppBehavior {
    off = "off",
    creditApplication = "credit_application",
    instantApproval = "instant_approval",
}

export interface CreditIQ {
    sourceOrgId: string;
    destinationOrgId: string;
    environment: CreditIQEnvironment | `${CreditIQEnvironment}`;
    menuing: boolean;
    prequal: boolean;
    credit_app_behavior: CreditAppBehavior;
}
